import React from "react";
import {Row} from "antd";
import {Box, CollapseHeaderNumber, DataBoxRow, MetricRow} from "./styles";
import {
    PercentageOutlined,
    FileSearchOutlined,
    CheckCircleOutlined,
    TeamOutlined,
    MinusCircleOutlined
} from "@ant-design/icons";
import {ConditionalTooltip} from "../_defaultComponents/ConditionalTooltip/ConditionalTooltip";
import {useTranslation} from "react-i18next";

const DataBox = ({data, name, onClick = () => {}, onCourierBoxClick = () => {}}) => {
    const {t} = useTranslation(["companyPage", "shiftCompliance"]);
    const plannedCourierColor = "#0958d9";
    const realizedCourierColor = "#08979c";
    const complianceRateColor = "#d46b08";
    const currentlyAvailableCourierCountColor = "#8fbe24";
    const notEnteredCourierCountColor = "#cf1322";
    const isGeneralStatistic = name === t("generalStatistic", {ns: "shiftCompliance"});

    return (
        <DataBoxRow onClick={onClick}>
            <div style={{flex: 1, minWidth: 0, overflow: "hidden"}}>
                <div style={{minWidth: 0}}>
                    <p
                        style={{
                            margin: 0,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap"
                        }}
                    >
                        {name?.capitalize() || data.name?.capitalize()}
                    </p>
                    {data.bmName && (
                        <p
                            style={{
                                margin: 0,
                                fontSize: 11,
                                color: "#8c8c8c",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap"
                            }}
                        >
                            Yetkili BM: {data.bmName}
                        </p>
                    )}
                </div>
            </div>
            <MetricRow>
                <ConditionalTooltip
                    condition
                    text={t(`detailButtons.scheduledCourier`, {ns: "companyPage"})}
                    child={
                        <Box
                            color={plannedCourierColor}
                            style={{cursor: "pointer"}}
                            onClick={e => {
                                e.stopPropagation();
                                onCourierBoxClick("planned");
                            }}
                        >
                            <FileSearchOutlined
                                style={{fontSize: "18px", color: plannedCourierColor}}
                            />
                            <CollapseHeaderNumber color={plannedCourierColor}>
                                {isGeneralStatistic
                                    ? data?.totalPlannedCourierCount
                                    : data?.plannedCourierCount}
                            </CollapseHeaderNumber>
                        </Box>
                    }
                    placement={"top"}
                />
                <ConditionalTooltip
                    condition
                    text={t(`detailButtons.realizedCourier`, {ns: "companyPage"})}
                    child={
                        <Box
                            color={realizedCourierColor}
                            style={{cursor: "pointer"}}
                            onClick={e => {
                                e.stopPropagation();
                                onCourierBoxClick("realized");
                            }}
                        >
                            <CheckCircleOutlined
                                style={{fontSize: "18px", color: realizedCourierColor}}
                            />
                            <CollapseHeaderNumber color={realizedCourierColor}>
                                {isGeneralStatistic
                                    ? data?.totalRealizedShiftCount
                                    : data?.realizedCourierCount}
                            </CollapseHeaderNumber>
                        </Box>
                    }
                    placement={"top"}
                />
                <ConditionalTooltip
                    condition
                    text={t(`detailButtons.notEnteredShiftCourier`, {ns: "companyPage"})}
                    child={
                        <Box
                            color={notEnteredCourierCountColor}
                            style={{cursor: "pointer"}}
                            onClick={e => {
                                e.stopPropagation();
                                onCourierBoxClick("notEntered");
                            }}
                        >
                            <MinusCircleOutlined
                                style={{fontSize: "18px", color: notEnteredCourierCountColor}}
                            />
                            <CollapseHeaderNumber color={notEnteredCourierCountColor}>
                                {isGeneralStatistic
                                    ? (data?.totalPlannedCourierCount ?? 0) -
                                      (data?.totalRealizedShiftCount ?? 0)
                                    : (data?.plannedCourierCount ?? 0) -
                                      (data?.realizedCourierCount ?? 0)}
                            </CollapseHeaderNumber>
                        </Box>
                    }
                    placement={"top"}
                />
                <ConditionalTooltip
                    condition
                    text={t(`detailButtons.currentlyAvailableCouriers`, {ns: "companyPage"})}
                    child={
                        <Box
                            color={currentlyAvailableCourierCountColor}
                            style={{cursor: "pointer"}}
                            onClick={e => {
                                e.stopPropagation();
                                onCourierBoxClick("available");
                            }}
                        >
                            <TeamOutlined
                                style={{
                                    fontSize: "18px",
                                    color: currentlyAvailableCourierCountColor
                                }}
                            />
                            <CollapseHeaderNumber color={currentlyAvailableCourierCountColor}>
                                {isGeneralStatistic
                                    ? data?.totalCurrentlyAvailableCourierCount
                                    : data?.currentlyAvailableCourierCount}
                            </CollapseHeaderNumber>
                        </Box>
                    }
                    placement={"top"}
                />
                <ConditionalTooltip
                    condition
                    text={t(`detailButtons.complianceRate`, {ns: "companyPage"})}
                    child={
                        <Box color={data?.complianceRate === 100 ? "#389e0d" : complianceRateColor}>
                            <PercentageOutlined
                                style={{
                                    fontSize: "18px",
                                    color:
                                        data?.complianceRate === 100
                                            ? "#389e0d"
                                            : complianceRateColor
                                }}
                            />
                            <CollapseHeaderNumber
                                color={
                                    data?.complianceRate === 100 ? "#389e0d" : complianceRateColor
                                }
                            >
                                {data?.complianceRate}
                            </CollapseHeaderNumber>
                        </Box>
                    }
                    placement={"top"}
                />
            </MetricRow>
        </DataBoxRow>
    );
};

export default DataBox;
